<div class="content-container">
	<mat-icon class="ico-notifications"></mat-icon>
	<span class="title" *ngIf="data.title" [innerHTML]="data.title | translate"></span>
	<p class="message" *ngIf="data.message" [innerHTML]="data.message | translate" (click)="onClick($event)"></p>
	<div class="obg-m-alert-buttons" *ngIf="data.buttons?.length">
		<ng-container *ngFor="let btn of data.buttons; trackBy: trackByButton">
			<button
				mat-flat-button
				[color]="getButtonColor(btn)"
				(click)="btn.handler()"
				[attr.test-id]="'alert-button-' + btn.testIdSuffix"
				[attr.data-test-id]="'alert-button-' + btn.testIdSuffix"
			>
				{{ btn.text | translate }}
			</button>
		</ng-container>
	</div>
</div>
